'use client';

import dynamic from 'next/dynamic';
import { useElevationControl } from '@web-store-platforms/providers/elevation';

const Footer = dynamic(() => import('@/components/Footer').then((module) => module.Footer), {
  ssr: false,
});

export function LoginFooter(): React.ReactElement {
  const zIndex = useElevationControl();

  return (
    <div className="flex w-full justify-center" style={{ zIndex }} data-testid="login-footer">
      <Footer isLoginPage />
    </div>
  );
}
